(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_language-region-category"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    // 获取区域标题块
    const blockList = document.querySelectorAll('.mob-region-btn');
    const isPad = window.innerWidth <= 1183;
    blockList.forEach(menu => {
      menu.addEventListener('click', function(event) {
        // 为每个菜单添加点击事件(仅移动端触发)
        if (window.innerWidth <= 1183) {
          const parentUl = this.closest('.region-block');
          const allBlocks = document.querySelectorAll('.region-block');
          
          // 如果当前块已展开，则收起
          if (parentUl.classList.contains('ro_switch-country-mob-active')) {
            parentUl.classList.remove('ro_switch-country-mob-active');
          } else {
            // 收起所有其他块
            allBlocks.forEach(block => {
              if (block !== parentUl) {
                block.classList.remove('ro_switch-country-mob-active');
              }
            });
            
            // 展开当前块
            parentUl.classList.add('ro_switch-country-mob-active');
          }
        }
      });
    });
    // 默认展开第一个
    // const firstBlock = document.querySelector('.region-block');
    // firstBlock.classList.add('ro_switch-country-mob-active');
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-selection-pane"] && !Shopify.designMode) return;
  try {
    if (!window.__productSelectionEditorTabsBound) {
    window.__productSelectionEditorTabsBound = true;
    document.addEventListener('shopify:block:select', (event) => {
      const pane = event.target.closest('.product-selection-pane');
      const tabs = pane?.closest('.product-selection-tabs');
      if (!tabs) return;
      const tab = Array.from(tabs.querySelectorAll('[role="tab"]'))
        .find((button) => button.getAttribute('aria-controls') === pane.id);
      tab?.click();
    });
  }
  } catch(e) { console.error(e); }
})();

})();
